export default __webpack_public_path__ + "static/timeline-08-73548b84fb194850396019e181b71f71.svg";